import React, { useEffect, useState } from "react";
import {
  List,
  Datagrid,
  TextField,
  ListActions,
  useStore,
  ReferenceField,
  NumberField,
  EditButton,
  SimpleList,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import CustomFilter from "features/CustomFilter";
import dataProvider from "server/dataProvider";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { settings } from "app";
import { activityRequests } from "api/activityApi";
import { studentRequests } from "api/studentApi";
import { useNotifyError } from "utils/useNotifyError";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { MobileListRow } from "features/MobileListRow";

export const CAPACITY_KEY = "foreignLanguageCapacityAcademicYearId.filters";

const ListForeignLanguageCapacity = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const notifyError = useNotifyError();
  // filters drives the <List> and the gate (persisted via useStore);
  // academicYearId is the draft bound to CustomFilter, committed on "Провери".
  const [filters, setFilters] = useStore(CAPACITY_KEY, null);
  const [academicYearId, setAcademicYearId] = useState(filters?.academicYearId ?? null);
  const [academicYears, setAcademicYears] = useState([]);

  const UserPermissions = getPermissions();

  useEffect(() => {
    const loadAcademicYears = async () => {
      try {
        const { data } = await dataProvider.customRequest(studentRequests.getAcademicYearsSelect(), null, "GET");
        setAcademicYears(data);
      } catch (err) {
        notifyError(err);
      }
    };
    loadAcademicYears();
  }, [notifyError]);

  const handleSearch = () => {
    if (!academicYearId) return;

    setFilters({ academicYearId });
  };

  return (
    <>
      <CustomFilter
        title="Капацитет по чужди езици"
        buttonLabel="Провери"
        buttonDisabled={!academicYearId}
        buttonOnClick={handleSearch}
        filters={[
          {
            type: "select",
            label: "Академична година",
            value: academicYearId,
            setValue: setAcademicYearId,
            choices: academicYears,
          },
        ]}
      />

      {filters && (
        <List
          title="Капацитет студенти"
          sx={settings.style.expandStyle}
          filter={filters}
          actions={
            <ListActions
              hasCreate={checkPermission(UserPermissions, permissions.canManageForeignLanguagesCapacities)}
            />
          }
          exporter={false}
        >
          {isMobile ? (
            <SimpleList
              linkType={false}
              sx={settings.style.mobileList}
              primaryText={() => (
                <MobileListRow
                  fields={[
                    {
                      label: "Чужд език",
                      value: (
                        <ReferenceField
                          reference={activityRequests.getActivityForeignLanguagesSelect()}
                          source="foreignLanguageId"
                        >
                          <TextField source="name" />
                        </ReferenceField>
                      ),
                    },
                  ]}
                />
              )}
              secondaryText={() => (
                <MobileListRow
                  fields={[{ label: "Капацитет студенти", value: <NumberField source="studentsCapacity" /> }]}
                />
              )}
              tertiaryText={() => (
                <SecuredComponent permission={permissions.canManageForeignLanguagesCapacities}>
                  <EditButton label="" />
                </SecuredComponent>
              )}
            />
          ) : (
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
            >
              <ReferenceField
                reference={activityRequests.getActivityForeignLanguagesSelect()}
                source="foreignLanguageId"
                label="Чужд език"
              >
                <TextField source="name" />
              </ReferenceField>
              <NumberField
                source="studentsCapacity"
                label="Капацитет студенти"
              />
              <SecuredComponent permission={permissions.canManageForeignLanguagesCapacities}>
                <EditButton />
              </SecuredComponent>
            </Datagrid>
          )}
        </List>
      )}
    </>
  );
};

export default ListForeignLanguageCapacity;
